import { useState } from 'react';
import { discussions } from '@/mocks/home';

export default function DiscussionSection() {
  const [liked, setLiked] = useState<string[]>([]);
  const [openReply, setOpenReply] = useState<string | null>(null);
  const [draft, setDraft] = useState('');
  const [note, setNote] = useState('');

  const toggleLike = (id: string) => {
    setLiked((prev) => (prev.includes(id) ? prev.filter((item) => item !== id) : [...prev, id]));
  };

  const handlePost = (id: string) => {
    if (!draft.trim()) {
      setNote('先说点什么再发送吧');
      return;
    }
    setNote('演示站点：评论未提交，仅停留在本页');
    setDraft('');
    setOpenReply(null);
    setTimeout(() => setNote(''), 2600);
  };

  return (
    <section id="discussion" className="bg-background-50 border-b border-background-200">
      <div className="mx-auto max-w-[1240px] px-4 md:px-8 py-8 md:py-12">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-4 mb-5 md:mb-6">
          <div>
            <span className="inline-flex items-center gap-1.5 text-xs font-medium text-primary-700 bg-primary-100 px-3 py-1 rounded-full">
              <i className="ri-chat-smile-2-line" />
              评论区现场
            </span>
            <h2 className="mt-3 font-heading text-xl md:text-2xl font-black text-foreground-950">
              正在热议
            </h2>
            <p className="mt-2 text-sm text-foreground-600">
              吃瓜的重点往往在评论区，这里挑出信息量较大的讨论。
            </p>
          </div>
          <div className="flex items-center gap-4 text-xs text-foreground-500">
            <span className="inline-flex items-center gap-1.5">
              <i className="ri-user-voice-line text-primary-600" />
              2,318 人正在参与
            </span>
            <span className="inline-flex items-center gap-1.5">
              <i className="ri-time-line" />
              每 30 秒更新
            </span>
          </div>
        </div>

        {note ? (
          <div className="mb-4 rounded-md border border-primary-200 bg-primary-50 px-4 py-2.5 text-xs text-primary-800">
            {note}
          </div>
        ) : null}

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-5">
          {discussions.map((item) => {
            const isLiked = liked.includes(item.id);
            return (
              <article key={item.id} className="rounded-lg border border-background-200 bg-background-50 p-4 md:p-5">
                <div className="flex items-start gap-3">
                  <div className="w-10 h-10 shrink-0 rounded-full overflow-hidden bg-background-200">
                    <img
                      src={item.avatar}
                      alt={`${item.user} 的头像 - 网红黑料讨论区`}
                      title={`${item.user} 讨论`}
                      className="w-full h-full object-cover object-top"
                    />
                  </div>
                  <div className="flex-1 min-w-0">
                    <div className="flex items-center gap-2 flex-wrap">
                      <span className="text-sm font-medium text-foreground-950">{item.user}</span>
                      <span className="text-[11px] text-foreground-500">{item.time}</span>
                      <span className="text-[11px] text-accent-900 bg-accent-100 px-2 py-0.5 rounded-full whitespace-nowrap">
                        {item.topic}
                      </span>
                    </div>
                    <p className="mt-2 text-sm text-foreground-800 leading-relaxed">{item.text}</p>

                    <div className="mt-3 flex items-center gap-4 text-xs text-foreground-600">
                      <button
                        type="button"
                        onClick={() => toggleLike(item.id)}
                        className={
                          isLiked
                            ? 'inline-flex items-center gap-1.5 text-primary-700 cursor-pointer'
                            : 'inline-flex items-center gap-1.5 hover:text-foreground-950 cursor-pointer'
                        }
                      >
                        <i className={isLiked ? 'ri-heart-3-fill' : 'ri-heart-3-line'} />
                        {item.likes + (isLiked ? 1 : 0)}
                      </button>
                      <button
                        type="button"
                        onClick={() => setOpenReply(openReply === item.id ? null : item.id)}
                        className="inline-flex items-center gap-1.5 hover:text-foreground-950 cursor-pointer"
                      >
                        <i className="ri-chat-3-line" />
                        {item.replies} 条回复
                      </button>
                      <button type="button" className="inline-flex items-center gap-1.5 hover:text-foreground-950 cursor-pointer">
                        <i className="ri-share-forward-line" />
                        分享
                      </button>
                    </div>

                    {openReply === item.id ? (
                      <div className="mt-3 pt-3 border-t border-background-200">
                        <div className="flex flex-col sm:flex-row gap-2">
                          <input
                            value={draft}
                            onChange={(event) => setDraft(event.target.value)}
                            type="text"
                            placeholder="说点什么…（演示，不会真的发出去）"
                            className="flex-1 h-9 px-3 rounded-md border border-background-300 bg-background-50 text-sm outline-none placeholder:text-foreground-400"
                          />
                          <button
                            type="button"
                            onClick={() => handlePost(item.id)}
                            className="h-9 px-4 rounded-md bg-primary-500 text-background-50 text-sm whitespace-nowrap cursor-pointer hover:bg-primary-600 transition-colors"
                          >
                            发送
                          </button>
                        </div>
                      </div>
                    ) : null}
                  </div>
                </div>
              </article>
            );
          })}
        </div>

        <div className="mt-5 flex items-center justify-center">
          <button
            type="button"
            className="inline-flex items-center gap-2 h-10 px-5 rounded-md border border-background-300 bg-background-50 text-sm text-foreground-800 whitespace-nowrap cursor-pointer hover:border-foreground-400 transition-colors"
          >
            <i className="ri-chat-history-line" />
            加载更多讨论
          </button>
        </div>
      </div>
    </section>
  );
}